/**
 * Dashboard Locataire Optimisé# Wi// Widgets spécialisés locataire
import RenterOverviewWidget from './widgets/RenterOverviewWidget';
import RenterReservationsWidget from './widgets/RenterReservationsWidget';
import RenterQuickActionsWidget from './widgets/RenterQuickActionsWidget';
// RenterUpcomingTripsWidget supprimé - pas pertinent spécialisés locataire
import RenterOverviewWidget from './widgets/RenterOverviewWidget';
import RenterReservationsWidget from './widgets/RenterReservationsWidget';
import RenterQuickActionsWidget from './widgets/RenterQuickActionsWidget';
// RenterUpcomingTripsWidget supprimé - pas pertinentrchitecture simple et élégante
 */

import React, { useState } from 'react';
import {
  Container,
  Box,
  Alert,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  IconButton,
  Tooltip,
  Typography
} from '@mui/material';
import {
  Refresh as RefreshIcon,
  Search as SearchIcon,
  Favorite as FavoriteIcon,
  Event as EventIcon
} from '@mui/icons-material';

// Hooks optimisés
import { useRenterDashboard, usePeriodSelector } from '../../hooks/useDashboardUnified';

// Composants de base réutilisables
import {
  DashboardHeader,
  MetricsGrid,
  DashboardWidget
} from './DashboardBase';

// Widgets spécialisés locataire
import RenterOverviewWidget from './widgets/RenterOverviewWidget';
import RenterReservationsWidget from './widgets/RenterReservationsWidget';
import RenterQuickActionsWidget from './widgets/RenterQuickActionsWidget';
import RenterUpcomingTripsWidget from './widgets/RenterUpcomingTripsWidget';

// Constants
import {
  STATS_PERIODS,
  PERIOD_LABELS,
  RENTER_METRICS,
  RENTER_METRIC_LABELS,
  METRIC_ICONS
} from '../../constants/dashboardConstants';

const RenterDashboardOptimized = () => {
  // Gestion des périodes
  const { period, updatePeriod } = usePeriodSelector();
  
  // Dashboard principal
  const { 
    dashboard, 
    loading, 
    error, 
    refresh,
    lastUpdated 
  } = useRenterDashboard({
    period,
    autoRefresh: true,
    refreshInterval: 300000 // 5 minutes
  });

  // Configuration des métriques - Seulement les utiles
  const metricsConfig = {
    [RENTER_METRICS.ACTIVE_RESERVATIONS]: {
      label: RENTER_METRIC_LABELS[RENTER_METRICS.ACTIVE_RESERVATIONS],
      icon: METRIC_ICONS[RENTER_METRICS.ACTIVE_RESERVATIONS],
      format: 'number',
      color: 'primary'
    },
    [RENTER_METRICS.COMPLETED_RESERVATIONS]: {
      label: RENTER_METRIC_LABELS[RENTER_METRICS.COMPLETED_RESERVATIONS],
      icon: METRIC_ICONS[RENTER_METRICS.COMPLETED_RESERVATIONS],
      format: 'number',
      color: 'success'
    }
    // SUPPRIMÉ: TOTAL_SPENT et UPCOMING_TRIPS (pas pertinents)
  };

  // Handlers
  const handlePeriodChange = (event) => {
    updatePeriod(event.target.value);
  };

  // Actions pour le header
  const headerActions = (
    <>
      <FormControl size="small" sx={{ minWidth: 150 }}>
        <InputLabel>Période</InputLabel>
        <Select
          value={period}
          label="Période"
          onChange={handlePeriodChange}
        >
          {Object.entries(PERIOD_LABELS).map(([key, label]) => (
            <MenuItem key={key} value={key}>
              {label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <Tooltip title="Rechercher des annonces">
        <IconButton color="primary">
          <SearchIcon />
        </IconButton>
      </Tooltip>

      <Tooltip title="Mes favoris">
        <IconButton color="error">
          <FavoriteIcon />
        </IconButton>
      </Tooltip>

      <Button
        variant="outlined"
        startIcon={<RefreshIcon />}
        onClick={refresh}
        disabled={loading}
        size="small"
      >
        Actualiser
      </Button>
    </>
  );

  // Gestion des erreurs
  if (error) {
    return (
      <Container maxWidth="xl" sx={{ py: 4 }}>
        <Alert 
          severity="error" 
          action={
            <Button color="inherit" size="small" onClick={refresh}>
              Réessayer
            </Button>
          }
        >
          {error}
        </Alert>
      </Container>
    );
  }

  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      {/* Header du dashboard */}
      <DashboardHeader
        title="Mon Dashboard"
        subtitle={`Vos réservations et activités - ${PERIOD_LABELS[period]}`}
        actions={headerActions}
      />

     

      {/* Widgets principaux */}
      <Grid container spacing={3}>
        {/* Vue d'ensemble */}
        <Grid item xs={12} lg={8}>
          <RenterOverviewWidget
            data={dashboard?.widgets?.overview}
            loading={loading}
            period={period}
            onRefresh={refresh}
          />
        </Grid>

        {/* Actions rapides */}
        <Grid item xs={12} lg={4}>
          <RenterQuickActionsWidget
            actions={dashboard?.widgets?.quick_actions}
            loading={loading}
          />
        </Grid>

        {/* Mes réservations */}
        <Grid item xs={12} md={8}>
          <RenterReservationsWidget
            data={dashboard?.widgets?.my_reservations}
            loading={loading}
            period={period}
            onRefresh={refresh}
          />
        </Grid>

        {/* Widget Voyages à venir supprimé - pas pertinent */}
      </Grid>

      {/* Informations de mise à jour */}
      {lastUpdated && !loading && (
        <Box mt={3} textAlign="center">
          <Typography variant="caption" color="text.secondary">
            Dernière mise à jour : {lastUpdated.toLocaleTimeString('fr-FR')}
          </Typography>
        </Box>
      )}
    </Container>
  );
};

export default RenterDashboardOptimized;
